import { render } from "./NcrmLeadsHome.vue?vue&type=template&id=b9b9a1a8&scoped=true"
import script from "./NcrmLeadsHome.vue?vue&type=script&lang=js"
export * from "./NcrmLeadsHome.vue?vue&type=script&lang=js"

import "./NcrmLeadsHome.styles.css?vue&type=style&index=0&id=b9b9a1a8&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b9a1a8"]])

export default __exports__